import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Settings2, ArrowRight, Sparkles } from 'lucide-react';
import { ProductConfigurator } from './ProductConfigurator';
import { theme } from '../../utils/theme';
import { useLanguage } from '../../contexts/LanguageContext';

// On définit l'URL du backend

export const ShopPage = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  
  const [isConfiguratorOpen, setIsConfiguratorOpen] = useState(false);

  if (isConfiguratorOpen) {
    return (
      <ProductConfigurator 
        onClose={() => setIsConfiguratorOpen(false)} 
      />
    );
  }

  return (
    <div className="min-h-screen" style={{ backgroundColor: theme.colors.background, color: theme.colors.text }}>

      <div className="max-w-7xl mx-auto px-4 py-12">
        
        {/* Configurator Landing */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6 border animate-pulse"
               style={{ backgroundColor: theme.colors.surface, borderColor: theme.colors.primary }}>
            <Sparkles size={16} style={{ color: theme.colors.primary }} />
            <span className="text-sm font-bold" style={{ color: theme.colors.primary }}>
              {t.shop?.new || "Nouveau"}
            </span>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold mb-6 tracking-tight text-white">
            {t.shop?.createFilter || "Créez votre filtre"} <span className="text-transparent bg-clip-text" style={{color: theme.colors.primary}}>{t.shop?.custom || "sur mesure"}</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto mb-12">
            {t.shop?.description || "Chaque fenêtre est unique. Utilisez notre configurateur interactif pour concevoir la protection solaire parfaite pour votre intérieur."}
          </p>

          <button 
            onClick={() => setIsConfiguratorOpen(true)}
            className="relative px-8 py-4 rounded-full font-bold text-xl transition-all hover:scale-105 overflow-hidden group mx-auto flex items-center justify-center gap-3"
            style={{ 
              background: theme.gradients.primary,
              color: '#000',
              boxShadow: `0 0 40px -10px ${theme.colors.primary}60`
            }}
          >
            <span className="relative z-10 flex items-center gap-3">
              <Settings2 size={24} />
              {t.shop?.startConfigurator || "Lancer le configurateur"}
              <ArrowRight size={24} />
            </span>
            <div className="absolute top-0 left-0 w-full h-full bg-white opacity-20 transform -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" />
          </button>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto text-left">
            <div className="p-6 rounded-2xl border border-white/10 bg-[#111]">
              <div className="w-10 h-10 rounded-full bg-orange-500/10 flex items-center justify-center mb-4 text-orange-500 font-bold">1</div>
              <h3 className="font-bold text-white mb-2">{t.shop?.step1Title || "Dimensions"}</h3>
              <p className="text-gray-400 text-sm">{t.shop?.step1Desc || "Saisissez les mesures exactes de vos fenêtres."}</p>
            </div>
            <div className="p-6 rounded-2xl border border-white/10 bg-[#111]">
              <div className="w-10 h-10 rounded-full bg-orange-500/10 flex items-center justify-center mb-4 text-orange-500 font-bold">2</div>
              <h3 className="font-bold text-white mb-2">{t.shop?.step2Title || "Modèle"}</h3>
              <p className="text-gray-400 text-sm">{t.shop?.step2Desc || "Choisissez la technologie adaptée à vos besoins."}</p>
            </div>
            <div className="p-6 rounded-2xl border border-white/10 bg-[#111]">
              <div className="w-10 h-10 rounded-full bg-orange-500/10 flex items-center justify-center mb-4 text-orange-500 font-bold">3</div>
              <h3 className="font-bold text-white mb-2">{t.shop?.step3Title || "Design"}</h3>
              <p className="text-gray-400 text-sm">{t.shop?.step3Desc || "Personnalisez les finitions pour votre intérieur."}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};